import React, { useState, useEffect } from "react";

const ValueInputField = (props) => {
    return <div className="form-group">
        <label className="floating" htmlFor={props.name}>{props.placeholder}</label>
        <input placeholder={props.placeholder}
               className="form-control uoValidateOnChange validateEmpty validateGreaterThanZero"
               type="number" name={props.name}
               value={props.value}
               onChange={(e) => { props.setValue(e.target.value)}}
        />
    </div>
}

export default ValueInputField;